const testimonialList = [
    {
        name: "Tengku F.",
        quote: "Been working with the Luran team for 2 years on a Liferay Project. Quality of work is excellent and the team is easy to work with.",
        profileImgUrl: "/images/testimonial/1.png",
        position: "Group CEO, SKALI",
    },
    {
        name: "Kamalnayan K.",
        quote: "I found a strong partner who could roadmap, migrate and deploy our application using Liferay framework on AWS while applying a strong DevOps layer on top of it. Mastered in moving us from a legacy, to a first class cloud environment.",
        profileImgUrl: "/images/testimonial/2.png",
        position: "Project Manager",
    },
    {
        name: "Tiur L.",
        quote: "We have worked with Luran, they are very communicative, and very skilled.",
        profileImgUrl: "/images/testimonial/profile.png",
        position: "CEO & Founder - Softbless",
    },
]

export default testimonialList;
